var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41719 6.74984H11.1897L7.78281 3.34297C7.48969 3.04984 7.48969 2.57484 7.78281 2.28234C8.07594 1.98922 8.55031 1.98922 8.84344 2.28234L13.5309 6.96984C13.5328 6.97109 13.5334 6.97359 13.5353 6.97547C13.6022 7.04359 13.6559 7.12422 13.6928 7.21297C13.7691 7.39672 13.7691 7.60297 13.6928 7.78672C13.6559 7.87609 13.6022 7.95609 13.5353 8.02422C13.5334 8.02609 13.5328 8.02859 13.5309 8.03047L8.84344 12.718C8.69719 12.8642 8.50531 12.9373 8.31344 12.9373C8.12094 12.9373 7.92906 12.8642 7.78281 12.718C7.48969 12.4248 7.48969 11.9498 7.78281 11.6573L11.1897 8.24984H2.41719C2.00281 8.24984 1.66719 7.91422 1.66719 7.49984C1.66719 7.08609 2.00281 6.74984 2.41719 6.74984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.ae35892197bd4c4aeeb0e9d109aa0810.svg";
export { ForwardRef as ReactComponent };